// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qH8A","col":"styles_col__1RR9u"};